// assets
import { IconHome } from '@tabler/icons';

// constant
const icons = { IconHome };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //
const services = {
  id: 'dashboard',
  // title: 'services',
  type: 'group',
  children: [
    {
      id: 'Servicelist',
      title: 'Home',
      type: 'item',
      url: '/product/dashboard',
      icon: icons.IconHome,
      breadcrumbs: false
    }
  ]};

export default services;
